import { createSlice } from "@reduxjs/toolkit";

export const mockInventoryDeviceAccount = {
  username: 'admin',
  password: 'password',
}

export const inventoryDeviceAccountSlice = createSlice({
  name: "onPermInventoryDeviceAccount",
  initialState: {
    resource: "inventoryDeviceAccount",
    data: { ...mockInventoryDeviceAccount },
  },
});

export default inventoryDeviceAccountSlice.reducer;